export const convertBirth = (num: string) => {
  if (!num) return "";
  var formatNum = "";

  num = num.replace(/\s/gi, "");
  try {
    if (num.length === 8) {
      formatNum = num.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
    }
  } catch (e) {
    formatNum = num;
    console.log(e);
  }
  return formatNum;
};

export const calculatePercentage = (part: number, whole: number) => {
  return Math.floor((part / whole) * 100);
};

export const patterns = {
  shape: [
    {
      type: "Circle",
      code: "1",
    },
    {
      type: "Rhombus",
      code: "2",
    },
    {
      type: "Star",
      code: "3",
    },
    {
      type: "Rectangle",
      code: "4",
    },
    {
      type: "Ellipse",
      code: "5",
    },
    {
      type: "Parallelogram",
      code: "6",
    },
    {
      type: "Cross",
      code: "7",
    },
    {
      type: "Arrow",
      code: "8",
    },
    {
      type: "Square",
      code: "9",
    },
    {
      type: "Triangle",
      code: "0",
    },
  ],
  color: [
    {
      type: "Red",
      color: "#FF0000F5",
      code: "1",
    },
    {
      type: "Orange",
      color: "#FF7A00F5",
      code: "2",
    },
    {
      type: "Yellow",
      color: "#FFD600F5",
      code: "3",
    },
    {
      type: "Light-Green",
      color: "#20E700F5",
      code: "4",
    },
    {
      type: "Green",
      color: "#009922F5",
      code: "5",
    },
    {
      type: "Sky",
      color: "#00C2FFF5",
      code: "6",
    },
    {
      type: "Blue",
      color: "#003FE2F5",
      code: "7",
    },
    {
      type: "Purple",
      color: "#BD00FFF5",
      code: "8",
    },
    {
      type: "Pink",
      color: "#EB00FFF5",
      code: "9",
    },
    {
      type: "Black",
      color: "#212121",
      code: "0",
    },
  ],
};
